export const hostingPackageFeatureNames = {
  UPLOAD_SIZE: 'uploadSize',
  SITE_STORAGE_QUOTA: 'siteStorageQuota',
  SITE_COUNT: 'siteCount',
  FREE_DOMAIN_PROMO: 'freeDomainPromo',
  PAGE_COUNT: 'pageCount',
  PARTNER_ADS: 'partnerAds',
  ANALYTICS: 'analytics',
  SITE_LANGUAGES: 'siteLanguages',
  SITE_AUTO_BACKUPS: 'siteAutoBackups',
  TRAFFIC_BUILDER: 'trafficBuilder',
  CUSTOMER_CARE: 'customerCare',
  CUSTOM_DOMAIN: 'customDomain',
  CUSTOM_CODE: 'customCode',
  PRIVATE_REGISTRATION: 'privateRegistration',
  DOMAIN_POINTING: 'domainPointing',
  UNLIMITED_SITE_BACKUPS: 'unlimitedSiteBackups',
  EXTERNAL_LINKS: 'externalLinks',
  MOBILE_PLUS: 'mobilePlus',
  PREMIUM_BLOCKS: 'premiumBlocks',
  PREMIUM_ICONS: 'premiumIcons',
  ADVANCED_COLOR_CUSTOMIZATION: 'advancedColorCustomization',
  PASSWORD_PROTECTED_PAGES: 'passwordProtectedPages',
  FORM_ATTACHMENTS: 'formAttachments',
  AI_PAGE_WIZARD: 'aiPageWizard',
  AI_LOCALIZATION: 'aiLocalization',
  AI_TEXT_ASSISTANT: 'aiTextAssistant',
  AI_BLOCK_GENERATOR: 'aiBlockGenerator',
  AI_TEXT_ASSISTANT_QUOTA: 'aiTextAssistantQuota',
  AI_BLOCK_GENERATION_QUOTA: 'aiBlockGenerationQuota',
  PREMIUM_BUTTON_PRESETS: 'premiumButtonPresets',
  PREMIUM_TEXT_DECORATIONS: 'premiumTextDecorations',
  PREMIUM_COMPOSITE_GROUP: 'premiumCompositeGroup',
  MULTILANGUAGE_SITE: 'multilanguageSite',
  PREMIUM_ICONS_PAYWALL: 'premiumIconsPaywall',
  PREMIUM_BLOCKS_AND_WIDGETS: 'premiumBlocksAndWidgets',
  AI: 'ai',
  PREMIUM_STOSK_IMAGES: 'premiumStockImages',
  PREMIUM_WEBSITE_TEMPLATES: 'premiumWebsiteTemplates',
  LEAD_CAPTURE_FORMS: 'leadCaptureForms',
  FIELDS_PER_FORM: 'feildsPerForm',
  FORM_SUBMISSIONS: 'formSubmissions',
  AI_SITE_WIZARD: 'aiSiteWizard',
  AI_DESIGN_ASSISTANT: 'aiDesignAssistant',
  SEARCH_ENGINE_OPTIMIZATION: 'searchEngineOptimization',
  AUTOMATIC_SITE_SPEED_OPTIMIZATION: 'automaticSiteSpeedOptimization',
  AUTOMATIC_IMAGE_OPTIMIZATION: 'automaticImageOptimization',
  REDIRECTS: 'redirects',
  SITEMAP_CONTROLS: 'sitemapControls',
  DDOS_PROTECTION: 'ddosProtection',
  GDRP_AND_CCPA_COMPLIANCE: 'gdrpAndCcpaCompliance',
  FREE_UNLIMITED_SSL: 'freeUnlimitedSsl',
  WEBSITE_EXPORT: 'websiteExport',
} as const;

export const ecommercePlanFeatureNames = {
  PRODUCT_LIMIT: 'productLimit',
  CATEGORIES: 'categories',
  E_GOODS_MAX_SIZE: 'eGoodsMaxSize',
  GOOGLE_SALES: 'googleSales',
  FACEBOOK_SALES: 'facebookSales',
  INSTAGRAM_SALES: 'instagramSales',
  INVENTORY_TRACKING: 'inventoryTracking',
  ABANDONED_CART_RECOVERY: 'abandonedCartRecovery',
  MULTILINGUAL: 'multilingual',
  TAX_CALCULATIONS: 'taxCalculations',
  MARKETING_EMAILS: 'marketingEmails',
  PRE_ORDERS: 'preOrders',
  SUBSCRIPTIONS: 'subscriptions',
  GIFT_CARDS: 'giftCards',
  COUPONS: 'coupons',
  AMAZON_SALES: 'amazonSales',
  EBAY_SALES: 'ebaySales',
  FACEBOOK_ADVERTISING: 'facebookAdvertising',
  GOOGLE_ADVERTISING: 'googleAdvertising',
  TIKTOK_ADVERTISING: 'tiktokAdvertising',
} as const;
